import { useQuery } from '@tanstack/react-query';
import { DocsRequests } from 'src/requests/docs';
import { Session } from 'src/state/session';
import { QueryKey, queryRetry } from 'src/utils/react-query';

export const useDocsQuery = (userId?: string) => {
  const queryKey = [QueryKey.DOCS];

  const {
    data: docs,
    isLoading: isDocsLoading,
    isFetching: isDocsFetching,
    refetch,
  } = useQuery(queryKey, () => DocsRequests.getDocs(), {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Session.isAuthenticated(),
    retry: queryRetry,
  });

  return {
    docs,
    isDocsLoading,
    isDocsFetching,
    refetch,
  };
};
